export enum EMode {
	filled = "filled",
	outlined = "outlined"
}